import type { FilterData } from '~/types/transactions/filters';

export type ViewConfig = {
  gridState: Record<string, unknown>;
  externalFilters: FilterData;
  shortcut: string;
};

export type ViewScope = 'global' | 'platform' | 'own';

export type SavedView = {
  id: string;
  name: string;
  isDefault: boolean;
  scope: ViewScope;
  position: number;
  config: ViewConfig;
};

export type CreateViewBody = {
  name: string;
  config: ViewConfig;
};

export const TRANSACTIONS_ALL_TABLE_IDENTIFIER = 'transactions-all';

export type ViewContentEnvelope = ViewConfig & {
  name: string;
};

export type DashboardViewModel = {
  Id: string;
  UserId?: number;
  PartnerName?: string;
  TableIdentifier: string;
  IsDefault: boolean;
  Scope: ViewScope;
  Position: number;
  ViewContent: ViewContentEnvelope;
  createdAt?: string;
  updatedAt?: string;
};

export type SaveViewBody = {
  TableIdentifier: string;
  IsDefault: boolean;
  ViewContent: ViewContentEnvelope;
};

export type UpdateViewBody = {
  name: string;
  viewContent: ViewContentEnvelope;
};

export type RenameViewBody = {
  name: string;
};

export type DuplicateViewBody = {
  name?: string;
};

export type ReorderViewsBody = {
  tableIdentifier: string;
  orderedIds: string[];
};

export type ActionMeta = {
  isDisabled: boolean;
  tooltip: string;
};
